module.exports = __webpack_public_path__ + "static/media/logo-cpcert.3b6d1794.png";